import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mainContainer', 'mainSlider', 'mainItem', 'thumbItem']
  initialize() {}
  connect() {
    this.selectedIndex = 0
    this.setSelected()
    this.mainContainerTarget.addEventListener('scrollend', () => {
      const width = this.mainSliderTarget.parentNode.getBoundingClientRect().width
      const position =
        this.mainSliderTarget.parentNode.getBoundingClientRect().left -
        this.mainSliderTarget.getBoundingClientRect().left
      this.selectedIndex = Math.round(position / width)
      this.setSelected()
    })
    window.addEventListener('resize', (e) => this.onResizeHandler(e))
    this.onResizeHandler()
  }
  onResizeHandler() {
    this.mainItemTargets.map((elem) => {
      elem.style.width = `${this.element.getBoundingClientRect().width}px`
    })
  }
  setSelected() {
    const selectedThumb = this.thumbItemTargets
      .map((elem, i) => {
        elem.classList[i === this.selectedIndex ? 'add' : 'remove']('selected')
        return elem
      })
      .find((elem) => Array.from(elem.classList).includes('selected'))
    selectedThumb?.querySelector('button').focus()
    selectedThumb?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
  }
  selectThumbHandler(e) {
    this.selectedIndex = parseInt(e.target.closest('li').dataset.index)
    const selectedMain = this.mainItemTargets.find((_, i) => i === this.selectedIndex)
    selectedMain?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
    this.setSelected()
  }
  nextHandler() {
    this.selectedIndex =
      this.selectedIndex < this.mainItemTargets.length - 1 ? this.selectedIndex + 1 : 0
    const selectedMain = this.mainItemTargets.find((_, i) => i === this.selectedIndex)
    selectedMain?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
    this.setSelected()
  }
  previousHandler() {
    this.selectedIndex =
      this.selectedIndex >= 1 ? this.selectedIndex - 1 : this.mainItemTargets.length - 1
    const selectedMain = this.mainItemTargets.find((_, i) => i === this.selectedIndex)
    selectedMain?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
    this.setSelected()
  }
}
